<script>
export default {
  name: 'NoClientsSelected',
  emits: ['reset'],
}
</script>

<template>
  <div class="empty-block">
    <div class="content">
      <h1>{{ $t('noClientSelectedInBookings.label') }}</h1>
      <p>{{ $t('noClientSelectedInBookings.paragraph') }}</p>

      <div class="button">
        <BaseButton
          outlined
          light
          width="150"
          color="black"
          text-color="black"
          class="classButton me-5"
          @click="$emit('reset')"
        >
          {{ $t('noClientSelectedInBookings.showAllClients') }}
        </BaseButton>

        <BaseButton
          prepend-icon="mdi mdi-plus"
          width="170"
          @click="$router.push({ name: 'bookings-create' })"
        >
          {{ $t('bookingCreate.submitBtn') }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/no-booking-found.scss';
</style>
